<template>
    <div>
        <PushForwardProducts v-if="this.blocktype.includes('PushForwardProducts')" :blockdatas="JSON.parse(blockdatas)"/>
        <PurchaseAids v-if="this.blocktype.includes('PurchaseAids')" :blockdatas="JSON.parse(blockdatas)"/>
        <EligibleAgency v-if="this.blocktype.includes('EligibleAgency')" :blockdatas="JSON.parse(blockdatas)"/>
        <BlogPosts v-if="this.blocktype.includes('BlogPosts')" :blockdatas="JSON.parse(blockdatas)" />
        <CorporationBlock v-if="this.blocktype.includes('corpo')" :blockdatas="JSON.parse(blockdatas)"/>
    </div>
</template>

<script>
import PushForwardProducts from "@/components/Zblockcontent/PushForwardProducts.vue"
import "@/globals.js";
import "@/assets/styles/zeborne/_main.scss";
import PurchaseAids from '@/components/Zblockcontent/PurchaseAids.vue';
import EligibleAgency from '@/components/Zblockcontent/EligibleAgency.vue';
import BlogPosts from "@/components/Zblockcontent/BlogPosts.vue";
import CorporationBlock from "@/components/Zblockcontent/CorporationBlock.vue";

export default {
    name: "Zblockcontent",

    components: {
        PushForwardProducts,
        PurchaseAids,
        EligibleAgency,
        BlogPosts,
        CorporationBlock
    },
    
    props: ['blocktype', 'blockdatas'],
    
}
</script>